import { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../utils/userContext";

export function LegacyUsersRedirect() {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const { id } = useParams();
  const orgId = user?.activeOrganisationId || user?.activeCompanyId;
  const customerId = user?.activeCustomerId;

  useEffect(() => {
    if (!orgId || !customerId) return;
    if (id) {
      navigate(
        `/admin/customers/${customerId}/organisations/${orgId}/users/${id}`,
        { replace: true }
      );
    } else {
      navigate(`/admin/customers/${customerId}/organisations/${orgId}`, { replace: true });
    }
  }, [navigate, id, orgId, customerId]);

  return null;
}

export function LegacyTeamRedirect() {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  useEffect(() => {
    const orgId = user?.activeOrganisationId || user?.activeCompanyId;
    const customerId = user?.activeCustomerId;
    if (orgId && customerId) {
      navigate(`/admin/customers/${customerId}/organisations/${orgId}`, { replace: true });
    }
  }, [navigate, user]);

  return null;
}

export function LegacyCompaniesRedirect() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (id && user?.activeCustomerId) {
      navigate(`/admin/customers/${user.activeCustomerId}/organisations/${id}`, {
        replace: true,
      });
    } else {
      navigate("/admin/customers", { replace: true });
    }
  }, [navigate, id, user]);

  return null;
}
